<div class="signature-flow-container">
    <!-- Header cu info document -->
    <div class="flow-header">
        <div class="header-info">
            <div class="header-title-row">
                <h2>
                    <mat-icon>account_tree</mat-icon>
                    FLUX SEMNATURI
                </h2>
                <button mat-raised-button class="export-pdf-btn" (click)="exportToPdf()" *ngIf="!isLoading && hasCompletSignatures" [disabled]="isExporting">
                    <mat-icon *ngIf="!isExporting">picture_as_pdf</mat-icon>
                    <mat-spinner *ngIf="isExporting" diameter="18" class="export-spinner"></mat-spinner>
                    {{ isExporting ? 'Se genereaza...' : 'Export PDF' }}
                </button>
            </div>
            <div class="document-info">
                <div class="info-row template-name">
                    <mat-icon>description</mat-icon>
                    <span class="label">Template:</span>
                    <span class="value">{{ flowData?.template_name || data.name }}</span>
                </div>
                <div class="info-badges">
                    <!-- Tip Document Badge -->
                    <span class="info-badge" [ngClass]="flowData?.is_address ? 'badge-address' : 'badge-official'">
                        <mat-icon>{{ flowData?.is_address ? 'mail' : 'article' }}</mat-icon>
                        {{ flowData?.document_type || 'Document Oficial' }}
                    </span>
                    <!-- Nr Exemplare Badge -->
                    <span class="info-badge badge-exemplare">
                        <mat-icon>content_copy</mat-icon>
                        {{ flowData?.is_dual ? '2 Exemplare (Dual)' : '1 Exemplar' }}
                    </span>
                </div>
                <div class="info-details" *ngIf="flowData?.directie_name || flowData?.compartiment_name || flowData?.category_name">
                    <div class="info-row" *ngIf="flowData?.directie_name">
                        <mat-icon>business</mat-icon>
                        <span class="label">Directie:</span>
                        <span class="value">{{ flowData?.directie_name }}</span>
                    </div>
                    <div class="info-row" *ngIf="flowData?.compartiment_name">
                        <mat-icon>folder</mat-icon>
                        <span class="label">Compartiment:</span>
                        <span class="value">{{ flowData?.compartiment_name }}</span>
                    </div>
                    <div class="info-row" *ngIf="flowData?.category_name">
                        <mat-icon>label</mat-icon>
                        <span class="label">Categorie:</span>
                        <span class="value">{{ flowData?.category_name }}</span>
                    </div>
                </div>
            </div>
        </div>
        <button mat-icon-button class="close-btn" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoading">
        <mat-spinner diameter="48"></mat-spinner>
        <p>Se incarca fluxul de semnaturi...</p>
    </div>

    <!-- Error State -->
    <div class="error-state" *ngIf="!isLoading && errorMessage">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h3>Eroare</h3>
        <p>{{ errorMessage }}</p>
        <button mat-raised-button color="primary" (click)="loadFlowData()">
            <mat-icon>refresh</mat-icon>
            Reincearca
        </button>
    </div>

    <!-- Empty State (cand nu sunt semnaturi) -->
    <div class="empty-state" *ngIf="!isLoading && !errorMessage && !hasCompletSignatures">
        <mat-icon class="empty-icon">assignment_late</mat-icon>
        <h3>Nu exista semnaturi configurate</h3>
        <p>Acest template nu are inca semnaturi configurate pentru fluxul de aprobare.</p>
        <button mat-raised-button color="primary" (click)="openSignaturesConfig()">
            <mat-icon>settings</mat-icon>
            Configureaza semnaturi
        </button>
    </div>

    <!-- Flow Diagram Container - Side by Side pentru Dual -->
    <div class="flow-diagrams-wrapper" *ngIf="!isLoading && !errorMessage && hasCompletSignatures">

        <!-- Exemplar Complet (Semnatari) - INTOTDEAUNA AFISAT -->
        <div class="flow-column" [ngClass]="{'single-column': !flowData?.is_dual}">
            <div class="column-header complet">
                <mat-icon>people</mat-icon>
                <span>EXEMPLAR COMPLET</span>
                <small>(Toti semnatarii)</small>
            </div>

            <div class="flow-content">
                <!-- Start Node -->
                <div class="flow-node start-node">
                    <div class="node-icon"><mat-icon>person_add</mat-icon></div>
                    <div class="node-content">
                        <span class="node-title">INTOCMITOR</span>
                        <span class="node-subtitle">Operator care genereaza documentul</span>
                    </div>
                </div>

                <div class="flow-connector">
                    <div class="connector-line"></div>
                    <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                </div>

                <!-- Signature Nodes pentru Exemplar Complet -->
                <ng-container *ngFor="let node of flowData?.exemplar_complet; let last = last">
                    <ng-container *ngTemplateOutlet="signatureNode; context: {node: node}"></ng-container>
                    <div class="flow-connector" *ngIf="!last">
                        <div class="connector-line"></div>
                        <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                    </div>
                </ng-container>

                <!-- End Node -->
                <div class="flow-connector">
                    <div class="connector-line"></div>
                    <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                </div>

                <div class="flow-node end-node">
                    <div class="node-icon"><mat-icon>verified_user</mat-icon></div>
                    <div class="node-content">
                        <span class="node-title">INREGISTRARE FINALA</span>
                        <span class="node-subtitle">Documentul revine la intocmitor pentru inregistrare si aplicare sigiliu institutie (SRP)</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Exemplar Cetatean - DOAR DACA E DUAL -->
        <div class="flow-column cetatean-column" *ngIf="flowData?.is_dual">
            <div class="column-header cetatean">
                <mat-icon>person</mat-icon>
                <span>EXEMPLAR CETATEAN</span>
                <small>(Copie pentru solicitant)</small>
            </div>

            <div class="flow-content">
                <!-- Start Node -->
                <div class="flow-node start-node">
                    <div class="node-icon"><mat-icon>person_add</mat-icon></div>
                    <div class="node-content">
                        <span class="node-title">INTOCMITOR</span>
                        <span class="node-subtitle">Operator care genereaza documentul</span>
                    </div>
                </div>

                <div class="flow-connector">
                    <div class="connector-line"></div>
                    <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                </div>

                <!-- Signature Nodes pentru Exemplar Cetatean -->
                <ng-container *ngFor="let node of flowData?.exemplar_cetatean; let last = last">
                    <ng-container *ngTemplateOutlet="signatureNode; context: {node: node}"></ng-container>
                    <div class="flow-connector" *ngIf="!last">
                        <div class="connector-line"></div>
                        <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                    </div>
                </ng-container>

                <!-- Empty state pentru cetatean daca nu are semnaturi -->
                <div class="empty-cetatean" *ngIf="!hasCetateanSignatures">
                    <mat-icon>info_outline</mat-icon>
                    <span>Nu sunt configurate semnaturi pentru exemplarul cetatean</span>
                </div>

                <!-- End Node pentru Cetatean -->
                <div class="flow-connector" *ngIf="hasCetateanSignatures">
                    <div class="connector-line"></div>
                    <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                </div>

                <div class="flow-node end-node" *ngIf="hasCetateanSignatures">
                    <div class="node-icon"><mat-icon>verified_user</mat-icon></div>
                    <div class="node-content">
                        <span class="node-title">INREGISTRARE FINALA</span>
                        <span class="node-subtitle">Document pentru cetatean cu sigiliu institutie</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Template reutilizabil pentru Signature Node -->
    <ng-template #signatureNode let-node="node">
        <div class="flow-node signature-node" [ngClass]="getSignTypeClass(node.sign_type)">
            <div class="node-order">{{ node.order }}</div>
            <div class="node-content">
                <div class="node-header">
                    <mat-icon>{{ getSignTypeIcon(node.sign_type) }}</mat-icon>
                    <span class="functie-name">{{ node.functie_name }}</span>
                </div>
                <div class="node-type">
                    <span class="type-badge" [ngClass]="getSignTypeClass(node.sign_type)">
                        {{ getSignTypeLabel(node.sign_type) }}
                    </span>
                </div>
                <div class="node-details" *ngIf="node.directie_name || node.compartiment_name || node.user_name">
                    <div *ngIf="node.directie_name" class="detail-row">
                        <mat-icon>business</mat-icon>
                        <span>{{ node.directie_name }}</span>
                    </div>
                    <div *ngIf="node.compartiment_name" class="detail-row">
                        <mat-icon>folder</mat-icon>
                        <span>{{ node.compartiment_name }}</span>
                    </div>
                    <div *ngIf="node.user_name" class="detail-row user-assigned">
                        <mat-icon>person</mat-icon>
                        <span>{{ node.user_name }}</span>
                        <span class="user-badge">Operator implicit</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- Legend -->
    <div class="flow-legend" *ngIf="!isLoading && !errorMessage && hasCompletSignatures">
        <span class="legend-title">Legenda:</span>
        <div class="legend-item sign-type-semnare">
            <mat-icon>edit</mat-icon> Semnare
        </div>
        <div class="legend-item sign-type-aprobare">
            <mat-icon>check_circle</mat-icon> Aprobare
        </div>
        <div class="legend-item sign-type-confirmare">
            <mat-icon>verified</mat-icon> Confirmare
        </div>
        <div class="legend-item sign-type-olografica">
            <mat-icon>draw</mat-icon> Semnare Olografica
        </div>
    </div>
</div>
